export default function Services() {
  const services = [
    {
      title: 'Nettoyage Intérieur',
      price: '80€',
      icon: 'ri-home-gear-line',
      features: [
        'Nettoyage des plastiques + finitions',
        'Nettoyage des vitres',
        'Nettoyage des panneaux de portes',
        'Aspiration en profondeur',
        'Pressing des sièges (suppression des taches)'
      ],
      note: 'Tarifs sous réserve de voir le véhicule, un supplément peut être appliqué selon la taille ou le type de saleté (poils d\'animaux, sable...)'
    },
    {
      title: 'Nettoyage Extérieur',
      price: '30€',
      icon: 'ri-car-washing-line',
      features: [
        'Décontamination et nettoyage de carrosserie',
        'Décontamination et nettoyage des jantes',
        'Nettoyage des vitres',
        'Application d\'un brillant à pneus'
      ]
    },
    {
      title: 'Intérieur + Extérieur',
      price: '100€',
      icon: 'ri-star-line',
      features: [
        'Nettoyage complet intérieur',
        'Nettoyage complet extérieur',
        'Service premium tout-en-un'
      ],
      note: 'Tarif sous réserve de voir le véhicule',
      popular: true
    }
  ];

  const additionalServices = [
    { name: 'Polissage sur devis', icon: 'ri-contrast-drop-line' },
    { name: 'Traitement céramique sur devis', icon: 'ri-shield-star-line' },
    { name: 'Rénovation de phares', price: 'À partir de 50€', icon: 'ri-lightbulb-flash-line' },
    { name: 'Pressing sièges uniquement (5 places)', price: '40€', icon: 'ri-armchair-line' },
    { name: 'Destickage sur devis', icon: 'ri-eraser-line' }
  ];

  return (
    <section id="prestations" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nos Prestations
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Des services professionnels adaptés à tous vos besoins de nettoyage automobile
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {services.map((service, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden ${
                service.popular ? 'ring-2 ring-[#0EA5E9] transform md:scale-105' : ''
              }`}
            >
              {service.popular && (
                <div className="absolute top-0 right-0 bg-[#0EA5E9] text-white px-4 py-1 text-xs font-semibold rounded-bl-lg whitespace-nowrap">
                  POPULAIRE
                </div>
              )}
              
              <div className="p-8">
                <div className="w-16 h-16 bg-gradient-to-br from-[#0EA5E9] to-[#0284C7] rounded-xl flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{service.title}</h3>
                <div className="flex items-baseline mb-6">
                  <span className="text-4xl font-bold text-[#0EA5E9]">{service.price}</span>
                </div>

                <ul className="space-y-3 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-check-line text-[#0EA5E9] text-lg mt-0.5 mr-2 flex-shrink-0"></i>
                      <span className="text-sm text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>

                {service.note && (
                  <p className="text-xs text-gray-500 italic border-t border-gray-200 pt-4">
                    {service.note}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Prestations à la Carte
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {additionalServices.map((service, index) => (
              <div
                key={index}
                className="flex items-center p-5 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors"
              >
                <div className="w-12 h-12 bg-[#0EA5E9]/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className={`${service.icon} text-xl text-[#0EA5E9]`}></i>
                </div>
                <div className="flex-1">
                  <p className="text-sm font-semibold text-gray-900">{service.name}</p>
                  {service.price && (
                    <p className="text-lg font-bold text-[#0EA5E9]">{service.price}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}